import { fetchAddons } from '@/clients/pops/client'

import { $addons, $promises } from './stores'

export const loadAddons = async () => {
  const promiseKey = 'loadAddons'

  if ($promises.get()[promiseKey]) {
    return $promises.get()[promiseKey]
  }

  const promise = (async () => {
    const popsAddons = await fetchAddons()

    $addons.set(popsAddons)
  })()

  $promises.setKey(promiseKey, promise)

  return promise
}
